export const MuiTableCell = {
  styleOverrides: {
    root: {
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '100%',
      padding: '16.5px 8px',
      border: '1px solid #D7D7D7',
    },
    head: {
      fontWeight: '600',
      color: ' #333333',
      backgroundColor: '#EFEFEF',
      border: 'none',
      borderBottom: '1px solid #D7D7D7',
    },
    body: {
      color: '#181818',
      border: 'none',
    },
  },
}
